define(["underscore","@bingads-webui-universal/primitive-utilities"], function(__WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__18__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 610);
/******/ })
/************************************************************************/
/******/ ({

/***/ 18:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__18__;

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(611);


/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Validation", {
  enumerable: true,
  get: function get() {
    return _index.Validation;
  }
});

var _index = __webpack_require__(612);

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Validation = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _required = __webpack_require__(613);

var string = _interopRequireWildcard(__webpack_require__(615));

var number = _interopRequireWildcard(__webpack_require__(617));

var _enum = __webpack_require__(618);

var array = _interopRequireWildcard(__webpack_require__(619));

var _passive = __webpack_require__(620);

var _custom = __webpack_require__(621);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function run(value, validators) {
  const failed = _underscore.default.find(validators, v => !v.isValid(value));

  return failed ? failed.message : undefined;
}

const Validation = {
  // validators
  required: _required.required,
  string,
  number,
  enum: _enum.enumeration,
  array,
  passive: _passive.passive,
  custom: _custom.custom,
  // end of validators
  run // run validation manually, for using without knockout

};
exports.Validation = Validation;

/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.required = required;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _base = __webpack_require__(614);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Define validator which check whether is empty when field is Required
 * @param {boolean} allowSpace - whether allow space in value endpoint
 * @param {I18n} i18n - provide getString callback, will be called
 * with args 'Validation_NotEmpty_Required_Field
 */
class Required extends _base.Base {
  constructor(allowSpace, i18n) {
    super(i18n);
    this.allowSpace = !!allowSpace;
    this.message = i18n.getString('Validation_NotEmpty_Required_Field');
  }

  isValidValue(value) {
    return _underscore.default.isFinite(value) || !_underscore.default.isEmpty(!this.allowSpace && _underscore.default.isString(value) ? value.trim() : value);
  }

}
/**
 * Create a required validator instance
 * @param {boolean} allowSpace - whether allow space in value endpoint
 * @param {I18n} i18n - provide getString callback
 * @returns {Validator} - required validator instance
 */


function required(allowSpace, i18n) {
  return new Required(allowSpace, i18n);
}

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Base = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var putil = _interopRequireWildcard(__webpack_require__(18));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base validator class, provide public interface
 * @param {I18n} i18n - provide callback getString to get error message, will be called
 * with args 'Validation_Base_Field_Not_Valid'
 */
class Base {
  constructor(i18n) {
    this.blockInput = false;
    this.nullable = false;
    this.i18n = i18n;
    this.message = i18n.getString('Validation_Base_Field_Not_Valid');
  }

  set(options = {}) {
    if (!_underscore.default.isUndefined(options.blockInput)) {
      this.blockInput = options.blockInput;
    }

    if (!_underscore.default.isUndefined(options.message)) {
      this.message = options.message;
    }

    if (!_underscore.default.isUndefined(options.nullable)) {
      this.nullable = options.nullable;
    }

    return this;
  }
  /**
   * Base method to validate value
   * @param {any} value - value to check
   * @returns {boolean} - whether value is valid
   */


  isValid(value) {
    return this.nullable && putil.isNil(value) || this.isValidValue(value);
  }
  /**
   * Base method to validate value, if valid, return undefined, otherwise, return error message
   * @param {any} value - value to validate
   * @returns {undefined|string} - return undefined if valid, otherwise return error message
   */


  validate(value) {
    return this.isValid(value) ? undefined : this.message;
  }

}

exports.Base = Base;

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLength = getLength;
exports.type = type;
exports.size = size;
exports.minSize = minSize;
exports.xss = xss;
exports.pattern = pattern;
exports.number = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var putil = _interopRequireWildcard(__webpack_require__(18));

var _base = __webpack_require__(614);

var number = _interopRequireWildcard(__webpack_require__(616));

exports.number = number;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get length of a string, if disgintuish CJK in string, each CJK character counts as 2 charts
 * otherwise, count as 1 charts
 * @param {string} str - string to compute length
 * @param {boolean} distinguishCJK - whether disgintuish CJK in string,
 * if not, the function equal to _.size, default value is false
 * @returns {int} - the length of string
 */
function getLength(str, distinguishCJK = false) {
  if (!distinguishCJK) {
    return _underscore.default.size(str);
  }

  let counts = _underscore.default.countBy(str, c => putil.hasCJK(c) ? 'cjk' : 'ascii');

  counts = _underscore.default.defaults(counts, {
    cjk: 0,
    ascii: 0
  });
  return counts.cjk * 2 + counts.ascii;
}
/**
 * Define a validator check type of value is string
 * @param {I18n} i18n - will be called in Base class
 */


class Type extends _base.Base {
  isValidValue(value) {
    return _underscore.default.isString(value);
  }

}
/**
 * Define a validator check size of string
 * @param {int} length - the max length of string
 * @param {I18n} i18n - will be called with args 'Validation_String_Max_Length'
 * @param {boolean} distinguishCJK - whether distinguish CJK in size check,
 * if true, one CJK character count 2
 */


class Size extends _base.Base {
  constructor(length, i18n, distinguishCJK = true) {
    super(i18n);
    this.blockInput = false;
    this.length = length || 0;
    this.distinguishCJK = distinguishCJK;
    this.message = i18n.getString('Validation_String_Max_Length', {
      maxlength: this.length
    });
  }

  isValidValue(value) {
    return _underscore.default.isString(value) && putil.getLength(value, this.distinguishCJK) <= this.length;
  }

}
/**
 * Define a validator check size of string
 * @param {int} length - the min length of string
 * @param {I18n} i18n - will be called with args 'Validation_String_Min_Length'
 * @param {boolean} distinguishCJK - whether distinguish CJK in size check,
 * if true, one CJK character count 2
 */


class MinSize extends _base.Base {
  constructor(length, i18n, distinguishCJK = true) {
    super(i18n);
    this.blockInput = false;
    this.length = length || 0;
    this.distinguishCJK = distinguishCJK;
    this.message = i18n.getString('Validation_String_Min_Length', {
      minlength: this.length
    });
  }

  isValidValue(value) {
    return _underscore.default.isString(value) && putil.getLength(value, this.distinguishCJK) >= this.length;
  }

}
/**
 * Define a validator check whether value is XSS code
 * @param {I18n} i18n - will be called with args 'Validation_String_Invalid_Characters'
 */


class XSS extends _base.Base {
  constructor(i18n) {
    super(i18n);
    this.message = i18n.getString('Validation_String_Invalid_Characters');
  }

  isValidValue(value) {
    return _underscore.default.isString(value) && !/<[^>]*>/.exec(value);
  }

}
/**
 * Define a validator check whether value match pattern
 * @param {string|RegExp} pattern - a pattern to test value
 * @param {I18n} i18n - will be called with args 'Validation_String_Invalid_Characters'
 */


class Pattern extends _base.Base {
  constructor(patt, i18n) {
    super(i18n);
    this.pattern = _underscore.default.isString(patt) ? new RegExp(patt) : patt;
    this.message = i18n.getString('Validation_String_Invalid_Characters');
  }

  isValidValue(value) {
    return this.pattern.test(value);
  }

}
/**
 * Create string type validate instance
 * @param {I18n} i18n - provide callback getString to get error message
 * @return {Validator} - string type validator
 */


function type(i18n) {
  return new Type(i18n);
}
/**
 * Create string size validate instance
 * @param {int} length - the max length of string
 * @param {boolean} distinguishCJK - whether distinguish CJK in size check
 * @param {I18n} i18n - provide getString to get error message
 * @returns {Validator} - string size validator
 */


function size(length, distinguishCJK, i18n) {
  return new Size(length, i18n, distinguishCJK);
}
/**
 * Create string size validate instance
 * @param {int} length - the min length of string
 * @param {boolean} distinguishCJK - whether distinguish CJK in size check
 * @param {I18n} i18n - provide getString to get error message
 * @returns {Validator} - string size validator
 */


function minSize(length, distinguishCJK, i18n) {
  return new MinSize(length, i18n, distinguishCJK);
}
/**
 * Create a validator check whether value is XSS code
 * @param {I18n} i18n - will be called with args 'Validation_String_Invalid_Characters'
 * @returns {Validator} - string xss validator
 */


function xss(i18n) {
  return new XSS(i18n);
}
/**
 * Create a validator check whether value match pattern
 * @param {string|RegExp} patt - a pattern to test value
 * @param {I18n} i18n - will be called with args 'Validation_String_Invalid_Characters'
 * @returns {Validator} - string pattern validator
 */


function pattern(patt, i18n) {
  return new Pattern(patt, i18n);
}

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.type = type;
exports.size = size;
exports.range = range;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var putil = _interopRequireWildcard(__webpack_require__(18));

var _base = __webpack_require__(614);

var _number = __webpack_require__(617);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Define a validator check type of input, whether the string can convert to a validate number
 * @param {I18n} i18n - provide a callback getString, will be called
 * with args 'Validation_Number_Require_Numeric'
 */
class Type extends _base.Base {
  constructor(i18n) {
    super(i18n);
    this.message = i18n.getString('Validation_Number_Require_Numeric');
  }

  isValidValue(value) {
    return _underscore.default.isString(value) && _underscore.default.isEmpty(value) || this.i18n.isValidDecimal(value, true);
  }

}
/**
 * Define a validator check size of string for string number
 * @param {int} integerLength - the length of int
 * @param {int} decimalLength - the length of decimal
 * @param {I18n} i18n - i18n will be called in class number/Size
 */


class Size extends _number.Size {
  isValidValue(value) {
    if (_underscore.default.isString(value) && _underscore.default.isEmpty(value)) {
      return true;
    }

    if (!this.i18n.isValidDecimal(value, true)) {
      return false;
    }

    const number = this.i18n.parseDecimal(value);

    if (putil.isNil(number)) {
      return false;
    }

    return super.isValidValue(number);
  }

}
/**
 * Define a validator check string number Range
 * @param {int|float} min - min value of input
 * @param {int|float} max - max value of input
 * @param {I18n} i18n - will be called in class number/Range
 */


class Range extends _number.Range {
  isValidValue(value) {
    if (_underscore.default.isString(value) && _underscore.default.isEmpty(value)) {
      return true;
    }

    if (!this.i18n.isValidDecimal(value, true)) {
      return false;
    }

    return super.isValidValue(this.i18n.parseDecimal(value));
  }

}
/**
 * Create string number type validate instance
 * @param {I18n} i18n - provide callback getString to get error message
 * @returns {Validator} - string number type validator
 */


function type(i18n) {
  return new Type(i18n);
}
/**
 * Create a string number size validator instance
 * @param {int} integerLength - the length of int
 * @param {int} decimalLength - the length of decimal
 * @param {I18n} i18n - will be called in class number/Range
 * @returns {Validator} - string number size validator
 */


function size(integerLength, decimalLength, i18n) {
  return new Size(integerLength, decimalLength, i18n);
}
/**
 * Create string number range validator instance
 * @param {int|float} min - min value of input
 * @param {int|float} max - max value of input
 * @param {I18n} i18n - will be called in class number/Range
 * @returns {Validator} - string number range validator
 */


function range(min, max, i18n) {
  return new Range(min, max, i18n);
}

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.type = type;
exports.size = size;
exports.range = range;
exports.Range = exports.Size = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var putil = _interopRequireWildcard(__webpack_require__(18));

var _base = __webpack_require__(614);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Define a number validator which check whether input is a number
 * @param {I18n} i18n - provide callback getString to get message,
 * will be called with args 'Validation_Number_Require_Numeric'
 */
class Type extends _base.Base {
  constructor(i18n) {
    super(i18n);
    this.blockInput = false;
    this.message = i18n.getString('Validation_Number_Require_Numeric');
  }

  isValidValue(value) {
    return putil.isNil(value) || _underscore.default.isNumber(value);
  }

}
/**
 * Define a number validator which check whether input is in a valid size
 * @param {int} integerLength - the length of int
 * @param {int} decimalLength - the length of decimal
 * @param {I18n} i18n - provide callback getString to get message,
 * will be called with args 'Validation_Number_Max_Length'
 */


class Size extends _base.Base {
  constructor(integerLength, decimalLength, i18n) {
    super(i18n);
    this.blockInput = false;
    this.message = i18n.getString('Validation_Number_Max_Length');
    this.integerLength = integerLength;
    this.decimalLength = decimalLength;
  }

  isValidValue(value) {
    // leave for required validator
    if (putil.isNil(value)) {
      return true;
    } // leave for number validator


    if (!_underscore.default.isNumber(value)) {
      return true;
    }

    let text = value.toString();

    if (value < 0) {
      text = text.substr(1);
    }

    const segments = text.split('.');

    if (this.integerLength && _underscore.default.size(segments[0]) > this.integerLength) {
      return false;
    }

    if (this.decimalLength === 0 && _underscore.default.size(segments) > 1) {
      return false;
    }

    if (this.decimalLength && _underscore.default.size(segments[1]) > this.decimalLength) {
      return false;
    }

    return true;
  }

}
/**
 * Define a nunmber validate which check whether input value in a valid range
 * @param {int|float} min - min value of input
 * @param {int|float} max - max value of input
 * @param {I18n} i18n - provide callback getString to get error message, will be called with args
 * 'Validation_Number_Range_Between', 'Validation_Number_Range_Min' or 'Validation_Number_Range_Max'
 */


exports.Size = Size;

class Range extends _base.Base {
  constructor(min, max, i18n) {
    super(i18n);
    this.min = min;
    this.max = max;

    if (_underscore.default.isFinite(min) && _underscore.default.isFinite(max)) {
      this.message = i18n.getString('Validation_Number_Range_Between', {
        min: i18n.formatDecimal(min, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }),
        max: i18n.formatDecimal(max, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        })
      });
    } else if (_underscore.default.isFinite(min)) {
      this.message = i18n.getString('Validation_Number_Range_Min', {
        min: i18n.formatDecimal(min, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        })
      });
    } else {
      this.message = i18n.getString('Validation_Number_Range_Max', {
        max: i18n.formatDecimal(max, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        })
      });
    }
  }

  isValidValue(value) {
    // leave for required validator
    if (putil.isNil(value)) {
      return true;
    } // leave for number validator


    if (!_underscore.default.isNumber(value)) {
      return true;
    }

    let result = true;

    if (_underscore.default.isFinite(this.min)) {
      result = result && value >= this.min;
    }

    if (_underscore.default.isFinite(this.max)) {
      result = result && value <= this.max;
    }

    return result;
  }

}
/**
 * Create a number type validator
 * @param {I18n} i18n - provide callback getString to get message
 * @returns {Validator} - number type validator instance
 */


exports.Range = Range;

function type(i18n) {
  return new Type(i18n);
}
/**
 * Create a size validator
 * @param {int} integerLength - the length of int
 * @param {int} decimalLength - the length of decimal
 * @param {I18n} i18n - provide callback getString to get message
 * @returns {Validator} - number size validator instance
 */


function size(integerLength, decimalLength, i18n) {
  return new Size(integerLength, decimalLength, i18n);
}
/**
 * Create a range validator
 * @param {int|float} min - min value of input
 * @param {int|float} max - max value of input
 * @param {I18n} i18n - provide callback getString to get message
 * @returns {Validator} - number range validator instance
 */


function range(min, max, i18n) {
  return new Range(min, max, i18n);
}

/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enumeration = enumeration;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _base = __webpack_require__(614);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Enum validator, which check whether value is in enumators
 * @param {array} enumerators - possible values
 * @param {I18n} i18n - provide getString callback, will be called in Base class
 */
class Enum extends _base.Base {
  constructor(enumerators, i18n) {
    super(i18n);
    this.enumerators = enumerators.slice();
  }

  isValidValue(value) {
    return _underscore.default.contains(this.enumerators, value);
  }

}
/**
 * Create a enum validator instance
 * @param {array} enumerators - possible values
 * @param {I18n} i18n - provide getString callback, will be called in Base class
 * @returns {Validator} - return a enum validator
 */


function enumeration(enumerators, i18n) {
  return new Enum(enumerators, i18n);
}

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.type = type;
exports.size = size;
exports.item = item;
exports.items = items;
exports.unique = unique;

var _underscore = _interopRequireDefault(__webpack_require__(8));

var _base = __webpack_require__(614);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Define a type validator which check the value type is an array
 * @param {I18n} i18n - provide callback getString to get error message for Base
 */
class Type extends _base.Base {
  isValidValue(value) {
    return _underscore.default.isArray(value);
  }

}
/**
 * Define a size validator which check the size of array between min and max
 * @param {int} min - the min size of array, default be 0
 * @param {int} max - the max size of array
 * @param {I18n} i18n - provide callback getString to get error message when validate failed, will
 * be callled with args 'Validation_Array_Size_Between' or 'Validation_Array_Size_Max'
 */


class Size extends _base.Base {
  constructor(min, max, i18n) {
    super(i18n);
    this.min = min || 0;
    this.max = max;

    if (this.min) {
      this.message = i18n.getString('Validation_Array_Size_Between', {
        min: this.min,
        max
      });
    } else {
      this.message = i18n.getString('Validation_Array_Size_Max', {
        max
      });
    }
  }

  isValidValue(value) {
    const valueSize = _underscore.default.size(value);

    return _underscore.default.isArray(value) && valueSize >= this.min && valueSize <= this.max;
  }

}

function passAll(validators, value) {
  return _underscore.default.every(validators, validator => validator.isValid(value));
}

function sizeNotFits(value, validators, additionalValidators) {
  return !additionalValidators && _underscore.default.size(value) > _underscore.default.size(validators);
}
/**
 * Create an array validator which inspects each item of an array by validators passed in.
 * @param {Validator[]} validators - validators for all items, each item should pass all validators.
 * @param {I18n} i18n - provide callback getString to get error message, will be called with args
 * 'Validation_Base_Field_Not_Valid' or 'Validation_Array_Items_Invalid'
 */


class Item extends _base.Base {
  constructor(validators, i18n) {
    super(i18n);
    this.validators = validators;

    this.message = value => {
      if (!_underscore.default.isArray(value)) {
        return i18n.getString('Validation_Base_Field_Not_Valid');
      }

      return i18n.getString('Validation_Array_Items_Invalid');
    };
  }
  /**
   * override function, check whether value is valid
   * @param {array} value - value to validate
   * @return {boolean} - whether value is valid
   */


  isValidValue(value) {
    return _underscore.default.isArray(value) && _underscore.default.isEmpty(this.invalidItems(value));
  }
  /**
   * Filter out invalid items.
   * @param {array} value - value to verify
   * @return {array} - return invalidate items
   * @see http://json-schema.org/latest/json-schema-validation.html#anchor37 for understanding conditions of successful validation.
   */


  invalidItems(value) {
    return _underscore.default.omit(value, _underscore.default.partial(passAll, this.validators));
  }

}
/**
 * Create an array validator which inspects items of an array.
 * @param {Validator[]} validators - validators for first _.size(validator) items.
 * @param {(Validator[]|boolean)} additionalValidators - boolean as allowing or
 * not additional items, Validator[] as validators for additional items.
 * @param {I18n} i18n - provide callback getString to get error message
 */


class Items extends _base.Base {
  constructor(validators, additionalValidators, i18n) {
    super(i18n);
    this.validators = validators;

    this.message = value => {
      if (!_underscore.default.isArray(value)) {
        return i18n.getString('Validation_Base_Field_Not_Valid');
      }

      if (sizeNotFits(value, validators, additionalValidators)) {
        return i18n.getString('Validation_Array_Size_Max', {
          max: _underscore.default.size(validators)
        });
      }

      return i18n.getString('Validation_Array_Items_Invalid');
    };
  }

  isValidValue(value) {
    return _underscore.default.isArray(value) && _underscore.default.isEmpty(this.invalidItems(value));
  }
  /**
   * Filter out invalid items.
   *
   * when additionalValidators is false, means max length of array is _.size(validators);
   * when additionalValidators is true, no validation for additional items;
   * when additionalValidators is Validator[], it will be applied to additional
   * items not covered by validators.
   * @param {array} value - value to verify
   * @return {array} - return invalid items
   * @see http://json-schema.org/latest/json-schema-validation.html#anchor37 for understanding conditions of successful validation.
   */


  invalidItems(value) {
    const validators = this.validators;
    let additionalValidators = this.additionalValidators;

    if (sizeNotFits(value, validators, additionalValidators)) {
      return value;
    } // additionalValidator could be validators or boolean


    if (additionalValidators === true) {
      additionalValidators = [];
    }

    return _underscore.default.omit(value, (val, index) => {
      const vs = validators[index] || additionalValidators;
      return passAll(vs, val);
    });
  }

}
/**
 * Create an array validator unique, check whether element unique in array
 * @param {I18n} i18n - provide callback getString, will be called
 * with args 'Validation_Array_Items_Duplicate'
 */


class Unique extends _base.Base {
  constructor(i18n) {
    super(i18n);
    this.message = i18n.getString('Validation_Array_Items_Duplicate');
  }

  isValidValue(value) {
    return _underscore.default.isArray(value) && _underscore.default.size(_underscore.default.uniq(value)) === _underscore.default.size(value);
  }

}
/**
 * Create array type validate instance
 * @param {I18n} i18n - provide callback getString to get error message
 * @return {Validator} - array type validator
 */


function type(i18n) {
  return new Type(i18n);
}
/**
 * Create size validate instance
 * @param {int} min - the min size of array
 * @param {int} max - the max size of array
 * @param {I18n} i18n - provide callback getString to get error message
 * @returns {Validator} - array size validator
 */


function size(min, max, i18n) {
  return new Size(min, max, i18n);
}
/**
 * Create item validate instance
 * @param {Validator[]} validators - validators for all items, each item should pass all validators.
 * @param {I18n} i18n - provide callback getString to get error message, will be called with args
 * 'Validation_Base_Field_Not_Valid' or 'Validation_Array_Items_Invalid'
 * @returns {Validator} - array item validator
 */


function item(validators, i18n) {
  return new Item(validators, i18n);
}
/**
 * Create an array items validator instance
 * @param {Validator[]} validators - validators for first _.size(validator) items.
 * @param {(Validator[]|boolean)} additionalValidators - boolean as allowing or
 * not additional items, Validator[] as validators for additional items.
 * @param {I18n} i18n - provide callback getString to get error message
 * @returns {Validator} - array items validator
 */


function items(validators, additionalValidators, i18n) {
  return new Items(validators, additionalValidators, i18n);
}
/**
 * Create an array unique validate instance
 * @param {I18n} i18n - provide callback getString, will be called
 * with args 'Validation_Array_Items_Duplicate'
 * @returns {Validator} - array unique validator
 */


function unique(i18n) {
  return new Unique(i18n);
}

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passive = passive;

var _base = __webpack_require__(614);

/**
 * Define passive validator
 * @param {I18n} i18n - provide callback getString to get message
 */
class Passive extends _base.Base {
  constructor(i18n) {
    super(i18n);
    this.error = null;
  }
  /**
   * Check whether value is valid
   * @param {any} value - value to be checked
   * @returns {boolean} - if value is valid return true, otherwise, return false
   */


  isValid(value) {
    if (this.error && this.error.value === value) {
      return false;
    }

    this.error = null;
    return true;
  }
  /**
   * Set error value and correspond message
   * @param {function|string} message - message of error
   * @param {any} value - error value
   * @returns {undefined} - no returns
   */


  setError(message, value) {
    this.error = {
      message,
      value
    };
    this.message = message;
  }

}
/**
 * Create passive validator instance
 * @param {I18n} i18n - provide callback getString to get message
 * @returns {Validator} - return passive validator instance
 */


function passive(i18n) {
  return new Passive(i18n);
}

/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.custom = custom;

var _base = __webpack_require__(614);

/**
 * Use to create a Customized validator
 * @param {function} method - validate function will be called to validate value
 * @param {function|string} message - a function or string, message of this validator
 * @param {boolean} blockInput - whether block input when validate failed
 * @param {I18n} i18n - i18n to get message, only used for Base class
 */
class Custom extends _base.Base {
  constructor(method, message, blockInput, i18n) {
    super(i18n);

    if (blockInput) {
      this.blockInput = blockInput;
    }

    if (message) {
      this.message = message;
    }

    this.isValid = method;
  }

}
/**
 * Create cusotmize validator instance
 * @param {function} method - validate function will be called to validate value
 * @param {function|string} message - a function or string, message of this validator
 * @param {boolean} blockInput - whether block input when validate failed
 * @param {I18n} i18n - i18n to get message, only used for Base class
 * @returns {Validator} - customized validator instance
 */


function custom(method, message, blockInput, i18n) {
  return new Custom(method, message, blockInput, i18n);
}

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })

/******/ })});;
